//Library Imports
import styled from "styled-components";

// application components goes here
import ButtonOutlineTwo from "../../Common/Components/ButtonOutlineTwo";
import Redo from "../../../assets/img/icons/redo.svg";
import Coding from "../../../assets/img/icons/coding.svg";
import Undo from "../../../assets/img/icons/undo.svg";

// styles goes here
import ButtonSmall from "modules/Common/Components/ButtonSmall";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";

interface ISettingsSidebar {
  emailName: string;
  emailId: number;
  toggleDisabled: boolean;
  handleSaveAsEmail: (
    value1: string,
    value2: string,
    value3: number,
    value4: any,
    value5: any,
    value6?: any,
  ) => void;
  handleSaveTemplate?: any;
  handleSaveEmail: () => void;
  enableSaveButtons: (value: boolean) => void;
  saveLoading?: boolean;
  emailType?: string;
}

const SettingsSidebar: React.FC<ISettingsSidebar> = (props: ISettingsSidebar) => {
  const { emailName, emailId, handleSaveAsEmail, handleSaveTemplate, handleSaveEmail, toggleDisabled, enableSaveButtons, saveLoading, emailType } = props;

  return (
    <>
      <Wrapper>
        <h3>DESIGN STUDIO</h3>
        <div className="d-flex justify-content-between stripo-buttons">
          <div className="icons d-flex justify-content-between">
            <div className="tooltip">
              <ButtonOutlineTwo icon={Redo} id="undoButton" />
              <span className="hidden">&nbsp;</span>
              <span className="tooltiptext">Undo</span>
            </div>
            <span className="mx-1">
              <div className="tooltip">
                <ButtonOutlineTwo icon={Undo} id="redoButton" />
                <span className="hidden">&nbsp;</span>
                <span className="tooltiptext">Redo</span>
              </div>
            </span>
            <div className="tooltip">
              <ButtonOutlineTwo icon={Coding} id="codeButton" />
              <span className="hidden">&nbsp;</span>
              <span className="tooltiptext">Code</span>
            </div>
          </div>
          <span className={`d-flex flex-wrap ${toggleDisabled ? "disabled" : ""}`}>
            <span>
              <ButtonSmall onClick={handleSaveEmail} value={"Save"} isDisabled={toggleDisabled || saveLoading} />
            </span>
            <CreateAsset
              noDropdown={true}
              noPortal={true}
              saveAsAsset={true}
              hideDynamic={true}
              campaignId={getQueryCampaignId()}
              assetId={emailId !== undefined ? emailId.toString() : "0"}
              name={emailName}
              noRedirection={true}
              handleSaveAsEmail={handleSaveAsEmail}
              handleSaveTemplate={handleSaveTemplate}
              className="ms-lg-2 hide-mac-article"
              disableSaveAs={enableSaveButtons}
              showSaveAsTemplateOption={emailType === "1"}
            >
              <span className="d-flex align-content-center flex-wrap">
                <ButtonSmall value={"Save As"} isDisabled={toggleDisabled || saveLoading} />
              </span>
            </CreateAsset>
          </span>
        </div>
        {/* {toggleDisabled && <div className="modal-backdrop fade show" />} */}
      </Wrapper>
    </>
  );
};

export default SettingsSidebar;

const Wrapper = styled.div`
  background-color: #fff;
  .tooltip {
    position: relative;
    display: inline-block;
    opacity: 1;
    z-index: 0;
    .tooltiptext {
      color: #ffffff;
      font-size: 11px;
      letter-spacing: 0.02px;
      line-height: 15px;
      text-align: center;
      background-color: #263153;
      visibility: hidden;
      border-radius: 4px;
      padding: 5px 0;
      position: absolute;
      z-index: 1;
      bottom: 125%;
      left: 50%;
      transform: translateX(-50%);
      opacity: 0;
      transition: opacity 0.3s;
      padding: 5px 10px;
      &:after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #263153 transparent transparent transparent;
      }
    }
    &:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
    }
  }
  h3 {
    color: #424b50;
    font-size: 20px;
    font-weight: 800;
    font-family: "Roboto Slab", serif;
    padding: 16px 15px;
    margin: 0;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .stripo-buttons {
    padding: 0 15px 8px 15px;
    .icons {
      max-height: 45px;
      .hidden {
        font-size: 0px;
        line-height: 0;
      }
    }
  }
`;
